import React from "react";
import PropTypes from "prop-types";
import { colorFillScale } from "../../utils/scaleTileGrid";
// Convert colorScale into legend items and format text where needed.
import { formatPerc } from "../../utils/dataHelpers/formatters";

const Legend = (props) => {
  const { title } = props;
  const colors = colorFillScale.range();
  const colorRanges = colorFillScale
    .range()
    .map((d) => colorFillScale.invertExtent(d));
  return (
    <div className="tile-grid-map__legend-container">
      <h3 className="tile-grid-map__legend-title">{title}</h3>

      <div className="tile-grid-map__legend-container-inner">
        {colors.map((color, idx) => {
          const text = formatPerc(colorRanges[idx][0], 0);
          return (
            <div className="tile-grid-map__legend-item" key={color}>
              <div
                className="tile-grid-map__legend-swatch"
                style={{ backgroundColor: color }}
              />
              <div>{text}+</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

Legend.defaultProps = {
  title: "",
};

Legend.propTypes = {
  title: PropTypes.string,
};

export default Legend;
